window.slate = window.slate || {};
window.theme = window.theme || {};

// Track popup display
slate.popUpShown = false;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

	/**
	 * For use when focus shifts to a container rather than a link
	 * eg for In-page links, after scroll, focus shifts to content area so that
	 * next `tab` is where user expects if focusing a link, just $link.focus();
	 *
	 * @param {JQuery} $element - The element to be acted upon
	 */
	pageLinkFocus: function($element) {
		var focusClass = 'js-focus-hidden';

		$element.first()
			.attr('tabIndex', '-1')
			.focus()
			.addClass(focusClass)
			.one('blur', callback);

		function callback() {
			$element.first()
				.removeClass(focusClass)
				.removeAttr('tabindex');
		}
	},

	/**
	 * If there's a hash in the url, focus the appropriate element
	 */
	focusHash: function() {
		var hash = window.location.hash;

		// is there a hash in the url? is it an element on the page?
		if (hash && document.getElementById(hash.slice(1))) {
			this.pageLinkFocus($(hash));
		}
	},

	/**
	 * When an in-page (url w/hash) link is clicked, focus the appropriate element
	 */
	bindInPageLinks: function() {
		$('a[href*=#]').on('click', function(evt) {
			this.pageLinkFocus($(evt.currentTarget.hash));
		}.bind(this));
	},

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	trapFocus: function(options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr('tabindex', '-1');
		options.$elementToFocus.focus();

		$(document).on(eventName, function(evt) {
			if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
				options.$container.focus();
			}
		});
	},

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	removeTrapFocus: function(options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}

		$(document).off(eventName);
	}
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
	
	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	cookiesEnabled: function() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled){
			document.cookie = 'testcookie';
			cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
		}
		return cookieEnabled;
	}
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

	/**
	 * Return an object from an array of objects that matches the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	findInstance: function(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
	 * Remove an object from an array of objects by matching the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	removeInstance: function(array, key, value) {
		var i = array.length;
		while(i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
	 * _.compact from lodash
	 * Remove empty/false items from array
	 * Source: https://github.com/lodash/lodash/blob/master/compact.js
	 *
	 * @param {array} array
	 */
	compact: function(array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
	 * _.defaultTo from lodash
	 * Checks `value` to determine whether a default value should be returned in
	 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	 * or `undefined`.
	 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
	 *
	 * @param {*} value - Value to check
	 * @param {*} defaultValue - Default value
	 * @returns {*} - Returns the resolved value
	 */
	defaultTo: function(value, defaultValue) {
		return (value == null || value !== value) ? defaultValue : value
	}
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
	/**
	 * Wrap tables in a container div to make them scrollable when needed
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
	 * @param {string} options.tableWrapperClass - table wrapper class name
	 */
	wrapTable: function(options) {
		var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

		options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
	},

	/**
	 * Wrap iframes in a container div to make them responsive
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
	 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
	 */
	wrapIframe: function(options) {
		var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

		options.$iframes.each(function() {
			// Add wrapper to make video responsive
			$(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
			
			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	}
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:section:reorder', this._onReorder.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function(container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (typeof constructor === 'undefined') {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function(evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === 'function') {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
	},

	_onSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onSelect === 'function') {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onDeselect === 'function') {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onReorder === 'function') {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockSelect === 'function') {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockDeselect === 'function') {
			instance.onBlockDeselect(evt);
		}
	},

	register: function(type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(function(index, container) {
			this._createInstance(container, constructor);
		}.bind(this));
	}
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
	var moneyFormat = '${{amount}}';

	/**
	 * Format money values based on your shop currency settings
	 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
	 * or 3.00 dollars
	 * @param  {String} format - shop money_format setting
	 * @return {String} value - formatted value
	 */
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || moneyFormat);

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ',');
			decimal = slate.utils.defaultTo(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var centsAmount = parts[1] ? (decimal + parts[1]) : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_space_separator':
				value = formatWithDelimiters(cents, 2, ' ', '.');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, ',', '.');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

		if (match) {
			var output = match[1],
			crop = src.match(/_crop_center/);

			if (crop) {
				output += '_crop_center';
			}

			return output;

		} else {
			return null;
		}
	}

	function imageSrcsetSizes(src) {
		var matchArray = src.split(','),
		outputArray = [];

		for (const i in matchArray) {
			var match = imageSize(matchArray[i]);

			if (match) {
				outputArray.push(match);
			}
		}

		if (outputArray.length > 0) {
			return outputArray;
		} else {
			return null;
		}
	}

	/**
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
		var match_asset = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?\d+)?$/i);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else if(match_asset) {
			var prefix = src.split(match_asset[0]);
			var suffix = match_asset[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}

	function getSizedSrcsetUrl(src, sizes) {
		var srcsetUrl = '';

		for (const i in sizes) {
			var imageWidth = sizes[i].split('x')[0];
			if (i != 0) {
				srcsetUrl += ', '
			}
			srcsetUrl += slate.Image.getSizedImageUrl(src, sizes[i]);
			srcsetUrl += ' ' + imageWidth + 'w';
		}

		if (srcsetUrl) {
			return srcsetUrl;
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		imageSrcsetSizes: imageSrcsetSizes,
		getSizedImageUrl: getSizedImageUrl,
		getSizedSrcsetUrl: getSizedSrcsetUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
	}

	Variants.prototype = $.extend({}, Variants.prototype, {

		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function() {
			var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
				var $element = $(element);
				var type = $element.attr('type');
				var currentOption = {};

				if (type === 'radio' || type === 'checkbox') {
					if ($element[0].checked) {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');

						return currentOption;
					} else {
						return false;
					}
				} else {
					currentOption.value = $element.val();
					currentOption.index = $element.data('index');

					return currentOption;
				}
			});

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = slate.utils.compact(currentOptions);

			return currentOptions;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function() {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;
			var found = false;

			variants.forEach(function(variant) {
				var satisfied = true;

				selectedValues.forEach(function(option) {
					if (satisfied) {
						satisfied = (option.value === variant[option.index]);
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function() {
			var variant = this._getVariantFromOptions();

			this.$container.trigger({
				type: 'variantChange',
				variant: variant
			});

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function(variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
				return;
			}

			this.$container.trigger({
				type: 'variantImageChange',
				variant: variant
			});
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function(variant) {
			if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
				return;
			}

			this.$container.trigger({
				type: 'variantPriceChange',
				variant: variant
			});
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param {object} variant - Currently selected variant
		 */
		_updateHistoryState: function(variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
			window.history.replaceState({path: newurl}, '', newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param {object} variant - Currently selected variant
		 */
		_updateMasterSelect: function(variant) {
			$(this.originalSelectorId, this.$container)[0].value = variant.id;
		}
	});

	return Variants;
})();

/**
 * Swatches Helpers
 * -----------------------------------------------------------------------------
 * Builds swatches on collection/product pages
 *
 * Current contents
 * - buildSwatches
 *
 */

slate.Swatches = (function() {
	function buildSwatches() {
		var swatchesOutput = '',
		$gridSwatchContainer = $('.product-grid-item .swatches');

		if($gridSwatchContainer.length) {
			$gridSwatchContainer.each(function() {
				var $thisSwatchContainer = $(this),
				$thisSwatchesList = $thisSwatchContainer.find('.swatches-list'),
				commonHandle = $thisSwatchContainer.data('product-handle');

				// Using the common product tag to find out all color variants as products in Shopify
				$.get('/collections/all/' + commonHandle + '?view=swatches').done(function(data) {
					var productArray = JSON.parse(data);

					productArray.forEach(function(product) {
						if(product.color) {
							var swatchURL = ' data-href="' + product.url + '"',
							swatchClass = '',
							swatchStyle = '';

							if(product.color == 'white') {
								swatchClass = ' has-border';
							}

							if(product.color_hex) {
								swatchStyle = ' style="background-color:' + product.color_hex + ';';

								if(product.image) {
									swatchStyle += ' background-image:url(' + product.image + ');';
								}

								swatchStyle += '"';
							}

							var $gridSwatch = $('<div' + swatchURL + swatchStyle + ' class="swatch' + swatchClass + '"></div>');

							$thisSwatchesList.append($gridSwatch);
						}
					});
				});
			});
		}

		return swatchesOutput;
	}

	return {
		buildSwatches: buildSwatches
	};
})();


/*================ Sections ================*/
theme.Slideshow = (function() {
	/**
	 * Slideshow section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Slideshow(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		// Only run if slideshow found
		if(this.$container.hasClass('main-slideshow')) {
			var $mainSlideshow = this.$container;

			$mainSlideshow.slick({
				arrows: $mainSlideshow.data('arrows'),
				dots: $mainSlideshow.data('dots'),
				fade: true,
				waitForAnimate: false,
				adaptiveHeight: false,
				autoplay: $mainSlideshow.data('autoplay'),
				pauseOnHover: false,
				rows: 0
			});
		}
	}

	Slideshow.prototype = $.extend({}, Slideshow.prototype, {
		onSelect: function(event) {
			// Reinitialize slideshow height (the adaptiveHeight variable doesn't work properly in the admin)
			var $mainSlideshow = $(event.target).find('.main-slideshow');
			$mainSlideshow.slick('resize');
		},
		onBlockSelect: function(event) {
			var $slide = $(event.target),
			$mainSlideshow = $slide.closest('.main-slideshow'),
			slideIndex = $slide.data('index');

			// Go to selected slide, pause autoplay
			$mainSlideshow.slick('slickGoTo', slideIndex);
			$mainSlideshow.slick('slickPause');
		},
		onBlockDeselect: function(event) {
			var $slide = $(event.target),
			$mainSlideshow = $slide.closest('.main-slideshow');

			// Resume autoplay
			if($mainSlideshow.hasClass('autoplay-slideshow')) {
				$mainSlideshow.slick('slickPlay');
			}
		}
	});

	return Slideshow;
})();

theme.FeaturedCollection = (function() {
	/**
	 * FeaturedCollection section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function FeaturedCollection(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id'),
		$productUpsellSlideshow = this.$container.find('.product-upsell-slideshow');
var infiniteSetting = $('body').hasClass('template-index') ? true : false;

		if ($productUpsellSlideshow.length) {
	const isIndexPage = $('body').hasClass('template-index') ? true : false;
          
console.log(isIndexPage);
	$productUpsellSlideshow.slick({
		accessibility: false,
		dots: true,
		draggable: true,
		waitForAnimate: false,
		rows: 0,
		slidesToScroll: 1,
		autoplay: infiniteSetting,
		autoplaySpeed: 2000,
		infinite: infiniteSetting,

		// Centered layout for index page
		centerMode: isIndexPage,
		centerMode: true,
centerPadding: '10%',
slidesToShow: 4,

		responsive: [
			{
				breakpoint: 990,
				settings: {
					centerMode: isIndexPage,
					centerPadding: isIndexPage ? '20%' : '0',
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 750,
				settings: {
					centerMode: isIndexPage,
					centerPadding: isIndexPage ? '10%' : '0',
					slidesToShow: isIndexPage ? 1 : 2.357,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					centerMode: true,
					centerPadding: '15%',
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}


	}

	return FeaturedCollection;
})();

theme.FeaturedDesigners = (function() {
	/**
	 * FeaturedDesigners section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function FeaturedDesigners(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id'),
		$designersSlideshow = this.$container.find('.featured-designers-slideshow');
var infiniteSetting = $('body').hasClass('template-index') ? true : false;
		if($designersSlideshow.length) {
          const isIndexPage = $('body').hasClass('template-index') ? true : false;
			$designersSlideshow.slick({
				accessibility: false, // Prevents jump to this slider on page load
				dots: false,
				draggable: true,
				waitForAnimate: false,
				rows: 0,
				slidesToShow: 4,
				slidesToScroll: 4,
              infinite: isIndexPage,
				autoplay: isIndexPage,
				// infinite: false,
                autoplaySpeed: 2000,
				responsive: [
					{
						breakpoint: 990,
						settings: {
							slidesToShow: 3.364,
							slidesToScroll: 3
						}
					},
					{
						breakpoint: 750,
						settings: {
							slidesToShow: 2.364,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1.364,
							slidesToScroll: 1
						}
					}
				]
			});
		}
	}

	return FeaturedDesigners;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
	 * @namespace product
 */

theme.Product = (function() {

	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartText: '[data-add-to-cart-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		afterpay: '.afterpay',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		productFeaturedImage: '[data-product-featured-image]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		productPriceAfterpay: '[data-product-price-afterpay]',
		productThumbs: '[data-product-single-thumbnail]',
		singleOptionSelector: '[data-single-option-selector]'
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson, this.$container).html()) {
			return;
		}

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject
		};

		this.settings = {};
		this.namespace = '.product';
		this.variants = new slate.Variants(options);
		this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

		this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
		this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
			slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

			if(this.$featuredImage.attr('srcset') !== undefined) {
				this.settings.imageSrcsetSizes = slate.Image.imageSrcsetSizes(this.$featuredImage.attr('srcset'));

				for (const i in this.settings.imageSrcsetSizes) {
					slate.Image.preload(this.productSingleObject.images, this.settings.imageSrcsetSizes[i]);
				}
			}

			this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
		}
	}

	Product.prototype = $.extend({}, Product.prototype, {

		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function(evt) {
			var variant = evt.variant;

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
				$(selectors.afterpay, this.$container).removeClass('hide');
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				$(selectors.afterpay, this.$container).addClass('hide');
				return;
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart + ' &ndash; ' + slate.Currency.formatMoney(variant.price, theme.moneyFormat));
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},

		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function(evt) {
			var variant = evt.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
			var $afterpay = $(selectors.afterpay, this.$container);
			var $afterpayPrice = $(selectors.productPriceAfterpay, this.$container);

			$(selectors.productPrice, this.$container)
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

			$afterpayPrice.html(slate.Currency.formatMoney((variant.price / 4), theme.moneyFormat));
			$afterpay.removeClass('hide');

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},

		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function(evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

			this.$featuredImage.attr('src', sizedImgUrl);

			if(this.$featuredImage.attr('srcset') !== undefined) {
				var sizedSrcsetUrl = slate.Image.getSizedSrcsetUrl(variant.featured_image.src, this.settings.imageSrcsetSizes);
				this.$featuredImage.attr('srcset', sizedSrcsetUrl);
			}
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
		}
	});

	return Product;
})();

theme.NewsletterPopup = (function() {
	var $newsletterPopup = $('.newsletter-popup');

	if($newsletterPopup.length) {
		// Show newsletter popup after 10s if it hasn't been shown yet
		if(!localStorage.getItem('newsletter_popup_shown')) {
			setTimeout(function() {
				$newsletterPopup.addClass('shown');
				localStorage.setItem('newsletter_popup_shown', true);
			}, 10000);
		}

		// Close newsleter popup
		$newsletterPopup.find('a.close').on('click', function(e) {
			e.preventDefault();
			$newsletterPopup.removeClass('shown');
		});
	}
})();

theme.CookiesBar = (function() {
	var $cookiesBar = $('.cookies-bar');

	if($cookiesBar.length) {
		// Show cookies bar if it hasn't been closed
		if(!localStorage.getItem('cookies_bar_shown')) {
			$cookiesBar.addClass('shown');
		}

		// Hide and don't show again on button click
		$cookiesBar.find('a.btn').on('click', function(e) {
			e.preventDefault();
			$cookiesBar.removeClass('shown');
			localStorage.setItem('cookies_bar_shown', true);
		});
	}
})();

theme.AboutChosen = (function() {
	/**
	 * AboutChosen section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function AboutChosen(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id'),
		$brandSlideshow = this.$container.find('.brand-slideshow');

		if($brandSlideshow.length) {
			$brandSlideshow.slick({
				accessibility: false, // Prevents jump to this slider on page load
				dots: false,
				draggable: true,
				waitForAnimate: false,
				rows: 0,
				slidesToShow: 1,
				infinite: false,
				variableWidth: true,
				outerEdgeLimit: true
			});
		}
	}

	return AboutChosen;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
	var $newAddressForm = $('#AddressNewForm');

	if (!$newAddressForm.length) {
		return;
	}

	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
			hideElement: 'AddressProvinceContainerNew'
		});
	}

	// Initialize each edit form's country/province selector
	$('.address-country-option').each(function() {
		var formId = $(this).data('form-id');
		var countrySelector = 'AddressCountry_' + formId;
		var provinceSelector = 'AddressProvince_' + formId;
		var containerSelector = 'AddressProvinceContainer_' + formId;

		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
			hideElement: containerSelector
		});
	});

	// Toggle new/edit address forms
	$('.address-new-toggle').on('click', function(e) {
		e.preventDefault();
		
		$newAddressForm.toggleClass('hide');
	});

	$('.address-edit-toggle').on('click', function(e) {
		var formId = $(this).data('form-id');

		e.preventDefault();

		$('#EditAddress_' + formId).toggleClass('hide');
	});

	$('.address-delete').on('click', function(e) {
		var $el = $(this);
		var formId = $el.data('form-id');
		var confirmMessage = $el.data('confirm-message');

		e.preventDefault();

		if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
			Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
		}
	});
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
	var config = {
		recoverPasswordForm: '#RecoverPassword',
		hideRecoverPasswordLink: '#HideRecoverPasswordLink'
	};

	if (!$(config.recoverPasswordForm).length) {
		return;
	}

	checkUrlHash();
	resetPasswordSuccess();

	$(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
	$(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

	function onShowHidePasswordForm(evt) {
		evt.preventDefault();
		toggleRecoverPasswordForm();
	}

	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === '#recover') {
			toggleRecoverPasswordForm();
		}
	}

	/**
	 *  Show/Hide recover password form
	 */
	function toggleRecoverPasswordForm() {
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	}

	/**
	 *  Show reset password success message
	 */
	function resetPasswordSuccess() {
		var $formState = $('.reset-password-success');

		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}

		// show success message
		$('#ResetSuccess').removeClass('hide');
	}
})();


$(document).ready(function() {
	var sections = new slate.Sections(),
	$html = $('html'),
	$body = $('body'),
	$allPopups = $('.popup'),
	$overlay = $('.overlay'),
	$miniCart = $('.mini-cart'),
	$mediaQuery = $('.mq'),
	$header = $('.full-header'),
	$mainMenuItems = $('.main-nav .site-nav > li.site-nav--has-submenu'),
	$submenus = $('.site-nav__submenu'),
	$mobileNav = $('.mobile-nav'),
	$toggleNav = $('a.toggle-nav'),
	$toggleSearch = $('a.search-link'),
	$slideOutSearch = $('.slide-out-search'),
	browserWidth = 'small',
	headerHeight = parseInt($body.css('padding-top'), 10),
	resizeTimer;

	sections.register('slideshow', theme.Slideshow);
	sections.register('featured-collection', theme.FeaturedCollection);
	sections.register('featured-designers', theme.FeaturedDesigners);
	sections.register('product', theme.Product);
	sections.register('newsletter-popup', theme.NewsletterPopup);
	sections.register('cookies-bar', theme.CookiesBar);
	sections.register('about-chosen', theme.AboutChosen);

	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));

	$('.in-page-link').on('click', function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});

	// Target tables to make them scrollable
	var tableSelectors = '.rte table';

	slate.rte.wrapTable({
		$tables: $(tableSelectors),
		tableWrapperClass: 'rte__table-wrapper',
	});

	// Target iframes to make them responsive
	var iframeSelectors =
		'.rte iframe[src*="youtube.com/embed"],' +
		'.rte iframe[src*="player.vimeo"]';

	slate.rte.wrapIframe({
		$iframes: $(iframeSelectors),
		iframeWrapperClass: 'rte__video-wrapper'
	});

	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}

	function checkMediaQuery() {
		if($mediaQuery.width() > 4) {
			browserWidth = 'xxlarge';
		} else if($mediaQuery.width() > 3) {
			browserWidth = 'xlarge';
		} else if($mediaQuery.width() > 2) {
			browserWidth = 'large';
		} else if($mediaQuery.width() > 1) {
			browserWidth = 'medium';
		} else {
			browserWidth = 'small';
		}
	}
	checkMediaQuery();

	function onResize() {
		checkMediaQuery();
	}

	// Reinitialize fixed header body padding on window resize
	$(window).on('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(onResize, 400);
	});

	// Show/hide dropdown menus on desktop
	$mainMenuItems.children('a').on('click', function(e) {
		checkMediaQuery();
		// Only run on desktop
		if(browserWidth == 'xxlarge') {
			e.preventDefault();
			e.stopPropagation(); // Don't count this as a body click because it will close the menu
			var $submenuParent = $(this).parent();

			if($submenuParent.hasClass('active')) {
				$submenuParent.removeClass('active');
				$overlay.removeClass('shown');
				slate.popUpShown = false;
			} else {
				$submenuParent.addClass('active');
				$mainMenuItems.not($submenuParent).removeClass('active');
				$html.removeClass('mini-cart-shown');
				$slideOutSearch.removeClass('shown');
				$overlay.addClass('shown');
				setTimeout(function() {
					slate.popUpShown = true;
				}, 300);
			}
		}
	});

	// Show/hide main nav panel on mobile
	$toggleNav.on('click', function(e) {
		e.preventDefault();
		e.stopPropagation(); // Don't count this as a body click because it will close the nav

		if($html.hasClass('mobile-nav-shown')) {
			$html.removeClass('mobile-nav-shown');
			$overlay.removeClass('shown');
			slate.popUpShown = false;
		} else {
			$html.addClass('mobile-nav-shown');
			$html.removeClass('mini-cart-shown');
			$slideOutSearch.removeClass('shown');
			$overlay.addClass('shown');
			setTimeout(function() {
				slate.popUpShown = true;
			}, 300);
		}
	});

	// Show/hide dropdown menus on mobile
	$('li.toggle-nav-mobile > a').on('click', function(e) {
		checkMediaQuery();
		// Only run on mobile
		if(browserWidth != 'xxlarge') {
			e.preventDefault();
			var $submenuParent = $(this).parent();

			if($submenuParent.hasClass('active')) {
				$submenuParent.removeClass('active').find('.site-nav__submenu').slideUp();
			} else {
				$submenuParent.addClass('active').find('.site-nav__submenu').slideDown();
			}
		}
	});

	// Toggle mobile search
	$toggleSearch.on('click', function(e) {
		e.preventDefault();
		e.stopPropagation(); // Don't count this as a body click because it will close the search

		if($slideOutSearch.hasClass('shown')) {
			$slideOutSearch.removeClass('shown');
			$overlay.removeClass('shown');
			slate.popUpShown = false;
		} else {
			$slideOutSearch.addClass('shown').find('input').focus();
			$html.removeClass('mobile-nav-shown');
			$html.removeClass('mini-cart-shown');

			checkMediaQuery();
			// Only run on desktop
			if(browserWidth == 'xxlarge') {
				$mainMenuItems.removeClass('active');
			}

			$overlay.addClass('shown');
			setTimeout(function() {
				slate.popUpShown = true;
			}, 300);
		}
	});

	// Close popups on button click
	$allPopups.on('click', 'a.close', function(e) {
		e.preventDefault();

		$html.removeClass('popup-shown');
		$allPopups.removeClass('shown');
		$overlay.removeClass('shown');
		slate.popUpShown = false;
	});

	// Close popups on overlay click
	$body.on('click', '.overlay', function() {
		if(slate.popUpShown) {
			$html.removeClass('popup-shown mini-cart-shown');
			$allPopups.removeClass('shown');
			$slideOutSearch.removeClass('shown');

			checkMediaQuery();
			// Only run on mobile
			if(browserWidth != 'xxlarge') {
				$html.removeClass('mobile-nav-shown');
			// Only run on desktop
			} else {
				$mainMenuItems.removeClass('active');
			}

			$overlay.removeClass('shown');
			slate.popUpShown = false;
		}
	});

	// Close popups on escape key press
	$(document).on('keydown', function(e) {
		// If escape key pressed
		if(e.keyCode == 27) {
			if(slate.popUpShown) {
				$html.removeClass('popup-shown mini-cart-shown');
				$allPopups.removeClass('shown');
				$slideOutSearch.removeClass('shown');

				checkMediaQuery();
				// Only run on mobile
				if(browserWidth != 'xxlarge') {
					$html.removeClass('mobile-nav-shown');
				// Only run on desktop
				} else {
					$mainMenuItems.removeClass('active');
				}

				$overlay.removeClass('shown');
				slate.popUpShown = false;
			}
		}
	});

	// Hide dropdowns on body click
	$body.on('click touchstart', function(e) {
		var hideOverlay = true;

		// Don't close mini cart if user has clicked inside it or on toggle icon click
		if(!($(e.target).closest($miniCart).length || $(e.target).closest('a.toggle-mini-cart').length)) {
			$html.removeClass('mini-cart-shown');
		} else {
			hideOverlay = false;
		}

		// Don't close slide out search on clicks inside it or on toggle icon click
		if(!($(e.target).closest($slideOutSearch).length || $(e.target).closest($toggleSearch).length)) {
			$slideOutSearch.removeClass('shown');
		} else {
			hideOverlay = false;
		}

		// Don't hide overlay on popup open or clicks inside popup
		if($(e.target).hasClass('show-popup') || $(e.target).closest($allPopups)) {
			hideOverlay = false;
		}

		checkMediaQuery();
		// Only run on mobile
		if(browserWidth != 'xxlarge') {
			// Don't close mobile nav on clicks inside it or on toggle icon click
			if(!($(e.target).closest($mobileNav).length || $(e.target).closest($toggleNav).length)) {
				$html.removeClass('mobile-nav-shown');
			} else {
				hideOverlay = false;
			}
		// Only run on desktop
		} else {
			// Don't close menu on clicks inside it
			if(!$(e.target).closest($submenus).length) {
				$mainMenuItems.removeClass('active');
			} else {
				hideOverlay = false;
			}
		}

		if(hideOverlay) {
			$overlay.removeClass('shown');
			slate.popUpShown = false;
		}
	});

	$body.on('click', '.accordion-toggle', function() {
		var $this = $(this),
		$accordion = $this.closest('.accordion'),
		accordionActive = true;

		if($accordion.hasClass('only-medium-down')) {
			checkMediaQuery();

			if(browserWidth == 'large' || browserWidth == 'xlarge' || browserWidth == 'xxlarge') {
				accordionActive = false;
			}
		} else if($accordion.hasClass('only-xlarge-down')) {
			checkMediaQuery();

			if(browserWidth == 'xlarge' || browserWidth == 'xxlarge') {
				accordionActive = false;
			}
		}

		if(accordionActive) {
			if($this.hasClass('active')) {
				$this.removeClass('active');
				$accordion.find('.accordion-content').slideUp();
			} else {
				$this.addClass('active');
				$accordion.find('.accordion-content').slideDown();

				// Close other accordions
				$accordion.parent().parent().find('.accordion').not($accordion).find('.accordion-toggle').removeClass('active').closest('.accordion').find('.accordion-content').slideUp();
			}
		}
	});

	var $navSlideshow = $('.nav-slideshow');

	// Only run if slideshow found
	if($navSlideshow.length) {
		$navSlideshow.slick({
			arrows: true,
			dots: false,
			fade: true,
			waitForAnimate: false,
			adaptiveHeight: false,
			autoplay: false,
			pauseOnHover: false,
			rows: 0,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1099,
					settings: "unslick"
				}
			]
		});
	}

	var $announcementsSlideshow = $('.announcements-slideshow');

	// Only run if slideshow found
	if($announcementsSlideshow.length) {
		$announcementsSlideshow.slick({
			arrows: false,
			dots: false,
			fade: true,
			waitForAnimate: false,
			adaptiveHeight: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 869,
					settings: "unslick"
				}
			]
		});
	}

	// Keep footer newsletter open if user has started typing
	$('.footer-newsletter input[type="email"]').on('focus', function() {
		$(this).closest('.footer-newsletter').addClass('active');
	});

	/*================ AJAX Cart ================*/
	ajaxCart.init({
		showPopup: false,
		miniCart: true,
		formSelector: '.add-to-cart-form',
		cartContainer: '#cart-container',
		miniCartContainer: '#mini-cart-container',
		addToCartSelector: '[data-add-to-cart]',
		cartCountSelector: '.cart-item-count',
		cartImgSize: '140x200_crop_center', // Shopify size: e.g. '300x200_crop_center'
		cartImgSrcset: ['140x200_crop_center', '200x286_crop_center'], // Array of Shopify sizes (width required for srcset)
		miniCartImgSize: '100x143_crop_center',
		miniCartImgSrcset: ['100x143_crop_center', '140x200_crop_center'],
		popupImgSize: '200x',
		popupImgSrcset: ['200x', '400x']
	});

	$body.on('click', 'a.toggle-mini-cart', function(e) {
		e.preventDefault();
		e.stopPropagation(); // Don't count this as a body click because it will close the cart

		if($html.hasClass('mini-cart-shown')) {
			$html.removeClass('mini-cart-shown');
			$overlay.removeClass('shown');
			slate.popUpShown = false;
		} else {
			ajaxCart.loadMini();
			$html.removeClass('mobile-nav-shown');
			$slideOutSearch.removeClass('shown');

			checkMediaQuery();
			// Only run on desktop
			if(browserWidth == 'xxlarge') {
				$mainMenuItems.removeClass('active');
			}
		}
	});

	/*================ Show Swatches ================*/
	if($body.hasClass('template-index') || $body.hasClass('template-product')) {
		// Not done on collection/search pages because we need to wait for filter app to load first
		slate.Swatches.buildSwatches();
	}

	if($body.hasClass('template-index') || $body.hasClass('template-product') || $body.hasClass('template-collection') || $body.hasClass('template-search')) {
		// Use JS to follow swatch link because it's already inside the <a>
		$body.on('click', '.product-grid-item .swatches .swatch', function(e) {
			var $this = $(this),
			url = $this.data('href');

			e.preventDefault();
			window.location.href = url;
		});
	}

	/*================ Collection/Search Page ================*/
	if($body.hasClass('template-collection') || $body.hasClass('template-search')) {
		$('.filter-toggle-mobile').on('click', function(e) {
			var $this = $(this),
			$dropdown = $this.parent().find('.filter-dropdown-mobile');

			if($this.hasClass('active')) {
				$this.removeClass('active');
				$dropdown.slideUp();
			} else {
				$this.addClass('active');
				$dropdown.slideDown();
			}
		});
	}

	/*================ Product Page ================*/
	if($body.hasClass('template-product')) {
		$('.product-image-slideshow').slick({
			draggable: true,
			waitForAnimate: false,
			rows: 0,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 749,
					settings: "unslick"
				}
			]
		});

		// Product swatches
		var $swatchContainer = $('.product-details .swatches'),
		$swatchesList = $swatchContainer.find('.swatches-list');

		if($swatchContainer.length) {
			var commonHandle = $swatchContainer.data('product-handle'),
			currentColorTag = $swatchContainer.data('product-color'),
			currentColorTitle = $swatchContainer.data('product-color-title');

			// Using the common product tag to find out all color variants as products in Shopify
			$.get('/collections/all/' + commonHandle + '?view=swatches').done(function(data) {
				var productArray = JSON.parse(data);

				productArray.forEach(function(product) {
					if(product.color) {
						var swatchURL = ' href="' + product.url + '"',
						swatchTitle =  ' data-title="' + product.color_title + '"',
						swatchClass = '',
						swatchStyle = '';

						if(product.color == 'white') {
							swatchClass = ' has-border';
						}

						if(product.color_hex) {
							swatchStyle = ' style="background-color:' + product.color_hex + ';';

							if(product.image) {
								swatchStyle += ' background-image:url(' + product.image + ');';
							}

							swatchStyle += '"';
						}

						// Compose the swatch element
						if(currentColorTag === product.color) {
							var $swatch = $('<div' + swatchTitle + swatchStyle + ' class="swatch' + swatchClass + ' active"></div>');
						} else {
							var $swatch = $('<a' + swatchURL + swatchTitle + swatchStyle + ' class="swatch' + swatchClass + '"></a>');
						}

						$swatchesList.append($swatch);
					}
				});
			});

			$swatchContainer.on({
				mouseenter: function () {
					var $this = $(this),
					swatchTitle = $this.data('title');

					// Don't change title if swatch already active
					if(!$this.hasClass('active')) {
						$swatchContainer.find('.swatch-color').text(swatchTitle);
					}
				},
				mouseleave: function () {
					var $this = $(this);

					// Don't change title if swatch already active
					if(!$this.hasClass('active')) {
						$swatchContainer.find('.swatch-color').text(currentColorTitle);
					}
				}
			}, '.swatch');
		}

		$('.show-popup').on('click', function(e) {
			e.preventDefault();

			var $this = $(this),
			popupClass = $this.attr('href').replace('#', '.'),
			$popup = $(popupClass);

			$html.addClass('popup-shown');
			$allPopups.removeClass('shown');
			$popup.addClass('shown');
			$overlay.addClass('shown');

			setTimeout(function() {
				slate.popUpShown = true;
			}, 300);
		});

		// If contact form submitted inside popup, show success message
		if(window.location.href.indexOf('contact_posted=true') !== -1) {
			$('.popup-form-success').removeClass('hide');
		}

		var $productUpsellSlideshow = $('.product-upsell-slideshow');

		if($productUpsellSlideshow.length) {
			$productUpsellSlideshow.each(function(index) {
				var $this = $(this);

				$this.slick({
					accessibility: false, // Prevents jump to this slider on page load
					dots: false,
					draggable: true,
					waitForAnimate: false,
					rows: 0,
					slidesToShow: 4,
					slidesToScroll: 4,
					infinite: false,
					responsive: [
						{
							breakpoint: 990,
							settings: {
								slidesToShow: 3.357,
								slidesToScroll: 3
							}
						},
						{
							breakpoint: 750,
							settings: {
								slidesToShow: 2.357,
								slidesToScroll: 2
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1.357,
								slidesToScroll: 1
							}
						}
					]
				});
			});
		}

		$('.all-related .titles a').on('click', function(e) {
			e.preventDefault();

			var $this = $(this),
			$allRelated = $this.closest('.all-related');

			// Toggle between slideshows
			if(!$this.hasClass('active')) {
				var slideshowToShow = $this.attr('href').replace('#', '.'),
				$otherSlideShow = $allRelated.find(slideshowToShow);

				$this.addClass('active').closest('.related-title').siblings().find('a').removeClass('active');

				$otherSlideShow.addClass('active').siblings().removeClass('active');
			}
		});
	}

	/*================ Article Page ================*/
	if($body.hasClass('template-article')) {
		var $relatedArticlesSlideshow = $('.related-articles-slideshow');

		if($relatedArticlesSlideshow.length) {
			$relatedArticlesSlideshow.slick({
				accessibility: false, // Prevents jump to this slider on page load
				dots: false,
				draggable: true,
				waitForAnimate: false,
				rows: 0,
				slidesToShow: 1.15,
				slidesToScroll: 1,
				infinite: false,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 479,
						settings: {
							slidesToShow: 2.15,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 869,
						settings: "unslick"
					}
				]
			});
		}
	}
});

$(document).ready(function(){
  $('.thumbnail-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-slider .zoom-container',
    vertical: true,
    focusOnSelect: true,
    arrows: false
  });

  $('.main-slider .zoom-container').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  dots: false, // initially hide dots for desktop
  asNavFor: '.thumbnail-slider',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});

	
	$(".zoom").mousemove(function(e){
		zoom(e);
	});

	function zoom(e){
		var x, y;
		var zoomer = e.currentTarget;
		if(e.offsetX) {
			offsetX = e.offsetX;
		} else {
			offsetX = e.touches[0].pageX;
		}

		if(e.offsetY) {
			offsetY = e.offsetY;
		} else {
			offsetX = e.touches[0].pageX;
		}
		x = offsetX/zoomer.offsetWidth*100;
		y = offsetY/zoomer.offsetHeight*100;
		zoomer.style.backgroundPosition = x+'% '+y+'%';
	}

  if ($(window).width() < 768) {
    if ($('.featured-designers.everybody-wearing-section .featured-designers-slideshow').hasClass('slick-initialized')) {
      $('.featured-designers.everybody-wearing-section .featured-designers-slideshow').slick('unslick');
    }
  }

});